var _circle, _path, _circle2, _path2, _path3, _polygon, _path4, _polygon2, _path5, _path6, _path7, _circle3, _polygon3, _path8, _path9, _path10, _path11, _path12, _polygon4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle4, _path29;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThanksSignup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a644d002-dee1-4c60-b6d8-14071a55f848",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 801.92126,
    height: 597.45739,
    viewBox: "0 0 801.92126 597.45739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "a21b076b-2a02-49a5-bb32-17a8ec3aa4f0",
    "data-name": "Ellipse 44",
    cx: 436.31397,
    cy: 42,
    r: 18.93406,
    fill: "#6c63ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e6e13b85-c0f0-465c-a6f6-5f502d6349d1",
    "data-name": "Path 395",
    d: "M633.47708,200.49409a1.96376,1.96376,0,0,1-1.1814-.39263l-.02113-.01585-4.44976-3.40392A1.97744,1.97744,0,0,1,630.231,193.543l2.88219,2.2102,6.81078-8.88542a1.9766,1.9766,0,0,1,2.7713-.36605l.00057.00043-.04227.05869.04342-.05869a1.979,1.979,0,0,1,.36562,2.77185l-8.011,10.44653a1.97779,1.97779,0,0,1-1.57284.77116Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "a589868e-34c5-408c-9ae2-7552629e8089",
    "data-name": "Ellipse 44",
    cx: 436.31397,
    cy: 170,
    r: 18.93406,
    fill: "#6c63ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "e165961b-e395-421d-ab84-b3c9bf16c3b4",
    "data-name": "Path 395",
    d: "M633.47708,328.49409a1.96376,1.96376,0,0,1-1.1814-.39263l-.02113-.01585-4.44976-3.40392A1.97744,1.97744,0,1,1,630.231,321.543l2.88219,2.2102,6.81078-8.88542a1.9766,1.9766,0,0,1,2.7713-.366l.00057.00043-.04227.05869.04342-.05869a1.979,1.979,0,0,1,.36562,2.77185l-8.011,10.44653a1.97779,1.97779,0,0,1-1.57284.77116Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M682.90354,520.23035a10.74577,10.74577,0,0,1,12.20913-11.06524l17.341-34.02233,9.79852,17.25595-17.96956,29.66266a10.804,10.804,0,0,1-21.37913-1.831Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#ffb7b7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "564.71 583.194 551.101 583.193 544.627 530.702 564.712 530.703 564.71 583.194",
    fill: "#ffb7b7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M767.21955,747.65678l-43.8805-.00163v-.555a17.08042,17.08042,0,0,1,17.07951-17.07924h.00108l26.80072.00108Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "638.483 583.194 624.874 583.193 618.4 530.702 638.485 530.703 638.483 583.194",
    fill: "#ffb7b7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M840.99286,747.65678l-43.88051-.00163v-.555a17.08044,17.08044,0,0,1,17.07952-17.07924h.00108l26.80072.00108Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M703.80614,490.62l-5.94091,9.90151s9.9015,0,11.88178,14.85223l7.92119-9.9015Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#e5e5e5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M807.77182,469.82685s15.84241,41.58627,18.81283,67.33016,7.92119,94.06416,7.92119,94.06416l9.90154,88.12335-27.72419,3.96059-11.88182-89.11344-26.734-88.12333-5.94091,88.12329-4.95073,80.20212-25.74387.99014-1.98032-83.17258-10.89164-105.946,5.94091-50.49761Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.17573,
    cy: 168.16436,
    r: 24.75374,
    fill: "#ffb7b7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "589.424 192.312 599.326 199.242 612.198 328.952 531.996 330.932 542.888 240.829 552.789 215.085 559.936 205.636 589.424 192.312",
    fill: "#e5e5e5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M790.4442,436.65684l3.02985-89.567s5.88152.4535,7.86179,3.424,34.65524,8.91134,34.65524,8.91134l-5.94091,92.08391s24.75374,73.27106,15.84242,77.23167-24.75374,2.97045-24.75374,2.97045Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M742.422,425.27011l10.50378-60.3646L729.55,380.71338,735.49093,424.28l-4.95074,29.70449s-18.81286,82.18242-12.872,85.15287,12.872,0,12.872,0L742.422,455.96475Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M736.48107,378.73309,729.55,380.71342l-2.97046,39.606-4.95073,34.65524L697.86523,497.551s11.88178-7.92118,16.83255,14.85226l26.17066-45.56388Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M783.93775,295.85068l4.66788-1.86876s-9.76008-10.74534-23.33948-9.81092l3.81928-4.20474s-9.3358-3.73747-17.82284,6.07344c-4.4615,5.15737-9.62347,11.21962-12.84142,18.04866h-4.999l2.08639,4.594-7.30239,4.594,7.49518-.82518a25.67158,25.67158,0,0,0-.20341,7.62,9.85929,9.85929,0,0,0,3.61036,6.44971h0s5.789-11.98274,5.789-13.8515v4.67188s4.66788-4.20468,4.66788-7.00779l2.5461,3.27032,1.273-5.13911,15.70106,5.13911-2.5461-4.20468,9.76012,1.40156-3.81928-5.13911,15.11132,21.22112S796.244,302.85847,783.93775,295.85068Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M790.33889,512.11024a10.74579,10.74579,0,0,1,14.12491-8.48465l23.61573-30.0088,6.26232,18.82982-23.386,25.61a10.804,10.804,0,0,1-20.617-5.94642Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#ffb7b7"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "631.506 350.24 622.595 361.132 610.713 340.339 615.663 331.428 631.506 350.24",
    fill: "#e5e5e5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M828.565,362.89069l7.92118-3.96059s5.94091,7.9212,6.93105,14.85225,5.94091,15.84238,5.94091,20.79313,13.8621,51.48777,13.8621,51.48777L831.53542,510.423s-6.93105-23.76358-21.78328-25.7439l24.75374-34.65528-13.8621-24.75371Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M999.96063,748.26737h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#cbcbcb"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M564.03937,363.2713h-365v-84h365Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M251.71718,307.04569a3.55641,3.55641,0,0,0,0,7.11281H511.37656a3.55641,3.55641,0,0,0,0-7.11281Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#6c63ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M251.71718,328.38411a3.55641,3.55641,0,0,0-.015,7.11281H415.86152a3.55641,3.55641,0,1,0,0-7.11281Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M564.03937,363.2713h-365v-84h365Zm-359-6h353v-72h-353Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#e5e5e5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M564.03937,491.2713h-365v-84h365Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M251.71718,435.04569a3.55641,3.55641,0,0,0,0,7.11281H511.37656a3.55641,3.55641,0,0,0,0-7.11281Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M251.71718,456.38411a3.55641,3.55641,0,0,0-.015,7.11281H415.86152a3.55641,3.55641,0,1,0,0-7.11281Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M564.03937,491.2713h-365v-84h365Zm-359-6h353v-72h-353Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#e5e5e5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M567.03937,235.2713h-365v-84h365Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M254.71718,179.04569a3.55641,3.55641,0,0,0,0,7.11281H514.37656a3.55641,3.55641,0,0,0,0-7.11281Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#6c63ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M254.71718,200.38411a3.55641,3.55641,0,0,0-.015,7.11281H418.86152a3.55641,3.55641,0,1,0,0-7.11281Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#6c63ff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M567.03937,235.2713h-365v-84h365Zm-359-6h353v-72h-353Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#e5e5e5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M938.2874,748.7287v-72.34S966.47907,727.67467,938.2874,748.7287Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#f1f1f1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M940.02887,748.716l-53.28962-48.92125S943.58444,713.71026,940.02887,748.716Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#f1f1f1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "b5ebad9a-150e-4d35-a0fa-e0e6655123db",
    "data-name": "Ellipse 44",
    cx: 484.31397,
    cy: 347.84559,
    r: 18.93406,
    fill: "#6c63ff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "a3d97315-c3ee-404f-9bfd-8b2853817976",
    "data-name": "Path 395",
    d: "M681.47708,506.33967a1.96375,1.96375,0,0,1-1.1814-.39262l-.02113-.01586-4.44976-3.40392a1.97744,1.97744,0,1,1,2.40623-3.13865l2.88219,2.2102,6.81078-8.88542a1.97662,1.97662,0,0,1,2.7713-.366l.00057.00043-.04227.0587.04342-.0587a1.979,1.979,0,0,1,.36562,2.77185l-8.011,10.44654a1.97782,1.97782,0,0,1-1.57284.77116Z",
    transform: "translate(-199.03937 -151.2713)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanksSignup);
export default __webpack_public_path__ + "static/media/thanks_signup.2662af3e.svg";
export { ForwardRef as ReactComponent };